const debug = true;

import toUpperSnakeCase from "./toUpperSnakeCase";

/**
 * Get the specified dimensions (height, width, or both) of the desired selector.
 * @param {string} selector - The selector of the element to measure.
 * @param {string} [dimension='both'] - 'height', 'width', or 'both' to specify which dimensions to get. Defaults to 'both'.
 */
const getDimensions = (selector, dimension = "both") => {
    if (typeof selector !== "string") {
        if (debug) {
            console.error(
                `Selector should be a string, but got ${typeof selector}: ${selector}`
            );
        }
        return;
    }

    const target = document.querySelector(selector);

    if (!target) {
        if (debug) {
            console.error(`No element matches the selector ${selector}`);
        }
        return;
    }

    const targetRect = target.getBoundingClientRect();
    const targetName = toUpperSnakeCase(
        selector.replace(/[^a-zA-Z0-9 _-]/g, "")
    );

    if (dimension === "height" || dimension === "both") {
        // Define CSS Global Variable
        document
            .querySelector("html")
            .style.setProperty(
                `--${targetName}_HEIGHT`,
                `${targetRect.height}px`
            );

        // Define JS Global Variable
        window[`${targetName}_HEIGHT`] = targetRect.height;

        if (debug) {
            console.debug(`${selector} height = ${targetRect.height}px`);
        }
    }

    if (dimension === "width" || dimension === "both") {
        // Define CSS Global Variable
        document
            .querySelector("html")
            .style.setProperty(
                `--${targetName}_WIDTH`,
                `${targetRect.width}px`
            );

        // Define JS Global Variable
        window[`${targetName}_WIDTH`] = targetRect.width;

        if (debug) {
            console.debug(`${selector} width = ${targetRect.width}px`);
        }
    }
};

export default getDimensions;
